export default "__VITE_ASSET__9026f949__"